import { WebCampaignKeyType } from '@/global.ts';
import { webCampaign } from '@/modules/webCampaign';

export class GoogleAnalyticsModule {
  /**
   * Campaigns for which Google Analytics events should not be sent
   */
  private static readonly EXCLUDED_CAMPAIGNS: WebCampaignKeyType[] = [
    'devmode',
    'g34bjedMGrp9_19B',
  ];

  /**
   * Checks if gtag is initialized
   */
  private static isInitialized(): boolean {
    return typeof window !== 'undefined' && typeof window.gtag === 'function';
  }

  /**
   * Tracks a Google Analytics event
   * Events are not sent for excluded campaigns
   */
  public static trackEvent(eventName: string, params?: unknown): void {
    const campaignKey = webCampaign.getKey();
    // Don't send events for excluded campaigns
    if (this.EXCLUDED_CAMPAIGNS.includes(campaignKey)) {
      console.log(
        'Google Analytics: Event not sent for campaign:',
        campaignKey,
      );
      return;
    }

    if (!this.isInitialized()) {
      console.error('Google Analytics (gtag) is not initialized');
      return;
    }

    console.log('Google Analytics log event: ', eventName);
    window.gtag('event', eventName, params);
  }
}
